/* tslint:disable */
/* eslint-disable */
import { DocumentDisplayModel as AceXFoundPortalCoreCaqModelsDocumentDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/document-display-model';
import { GlobalEnumsAceErfolgtausstehend as AceXFoundPortalCoreEntitiesGlobalEnumsAceErfolgtausstehend } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-erfolgtausstehend';
import { GlobalEnumsAceStatuszuwendungsbest as AceXFoundPortalCoreEntitiesGlobalEnumsAceStatuszuwendungsbest } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-statuszuwendungsbest';
import { GlobalEnumsAceTyp as AceXFoundPortalCoreEntitiesGlobalEnumsAceTyp } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-typ';
import { AceZahlungAceZahlungEnumsAceZahlungStatuscode as AceXFoundPortalCoreEntitiesAceZahlungAceZahlungEnumsAceZahlungStatuscode } from '../../../../../../ace/xFound/Portal/Core/Entities/ace-zahlung-ace-zahlung-enums-ace-zahlung-statuscode';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { DocumentDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsDocumentDisplayModelFormGroup } from '@/api/model-index';

export interface IPaymentDisplayModel {
  amount?: null | number;
  datumMittelabruf?: null | string;
  documents?: null | Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>;
  id?: string;
  isDisabled?: boolean;
  isSelected?: boolean;
  mittelabruf?: AceXFoundPortalCoreEntitiesGlobalEnumsAceErfolgtausstehend;
  paymentDate?: null | string;
  paymentType?: AceXFoundPortalCoreEntitiesGlobalEnumsAceTyp;
  projektId?: null | string;
  statusgrund?: AceXFoundPortalCoreEntitiesAceZahlungAceZahlungEnumsAceZahlungStatuscode;
  zuwendungsbestaetigung?: AceXFoundPortalCoreEntitiesGlobalEnumsAceStatuszuwendungsbest;
}
export class PaymentDisplayModel extends BaseModel implements IPaymentDisplayModel {
  amount?: null | number;
  datumMittelabruf?: null | string;
  documents?: null | Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>;
  id?: string;
  isDisabled?: boolean;
  isSelected?: boolean;
  mittelabruf?: AceXFoundPortalCoreEntitiesGlobalEnumsAceErfolgtausstehend;
  paymentDate?: null | string;
  paymentType?: AceXFoundPortalCoreEntitiesGlobalEnumsAceTyp;
  projektId?: null | string;
  statusgrund?: AceXFoundPortalCoreEntitiesAceZahlungAceZahlungEnumsAceZahlungStatuscode;
  zuwendungsbestaetigung?: AceXFoundPortalCoreEntitiesGlobalEnumsAceStatuszuwendungsbest;
}
class BasePaymentDisplayModelFormGroup extends FormGroup {
  private static _instance: PaymentDisplayModelFormGroup;
  
  public static get Instance(): PaymentDisplayModelFormGroup {
    this._instance = new PaymentDisplayModelFormGroup({
      amount: new FormControl(null),
      datumMittelabruf: new FormControl(null),
      documents: new FormArray([]),
      id: new FormControl(null),
      isDisabled: new FormControl(null),
      isSelected: new FormControl(null),
      mittelabruf: new FormControl(null),
      paymentDate: new FormControl(null),
      paymentType: new FormControl(null),
      projektId: new FormControl(null),
      statusgrund: new FormControl(null),
      zuwendungsbestaetigung: new FormControl(null),
    });

    return this._instance;
  }
}


export class PaymentDisplayModelFormGroup extends BasePaymentDisplayModelFormGroup {
  public get Amount(): FormControl {
    return this.controls["amount"] as FormControl;
  }
  public get DatumMittelabruf(): FormControl {
    return this.controls["datumMittelabruf"] as FormControl;
  }
  public get Documents(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsDocumentDisplayModelFormGroup> {
    return this.controls["documents"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsDocumentDisplayModelFormGroup>;
  }
  public get Id(): FormControl {
    return this.controls["id"] as FormControl;
  }
  public get IsDisabled(): FormControl {
    return this.controls["isDisabled"] as FormControl;
  }
  public get IsSelected(): FormControl {
    return this.controls["isSelected"] as FormControl;
  }
  public get Mittelabruf(): FormControl {
    return this.controls["mittelabruf"] as FormControl;
  }
  public get PaymentDate(): FormControl {
    return this.controls["paymentDate"] as FormControl;
  }
  public get PaymentType(): FormControl {
    return this.controls["paymentType"] as FormControl;
  }
  public get ProjektId(): FormControl {
    return this.controls["projektId"] as FormControl;
  }
  public get Statusgrund(): FormControl {
    return this.controls["statusgrund"] as FormControl;
  }
  public get Zuwendungsbestaetigung(): FormControl {
    return this.controls["zuwendungsbestaetigung"] as FormControl;
  }
  

}

export module PaymentDisplayModelForm
  {
    export class FormFields
    {
      static _amount: string = "amount";
      static _datumMittelabruf: string = "datumMittelabruf";
      static _documents: string = "documents";
      static _id: string = "id";
      static _isDisabled: string = "isDisabled";
      static _isSelected: string = "isSelected";
      static _mittelabruf: string = "mittelabruf";
      static _paymentDate: string = "paymentDate";
      static _paymentType: string = "paymentType";
      static _projektId: string = "projektId";
      static _statusgrund: string = "statusgrund";
      static _zuwendungsbestaetigung: string = "zuwendungsbestaetigung";
    }
  }

